module.exports = __webpack_public_path__ + "img/icon_arrow_left_dark_grey.d6366f4b.svg";